import { guid } from '@/mixins/guid';

export function tblShape(mrg = {}) {
  return () => (Object.assign({
    _id: guid.methods.guid(),
    text: 'Text',
  }, mrg));
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/table/utils.js